import React, { useContext } from 'react';
import { ComponentContext } from '../../contexts';
import { Row } from '../row';
import { DH } from '../../data-hooks';
import { DummyRasterizer } from '../../dummy-rasterizer';
import { useMultiRow } from './use-multi-row';
export const MultiRow = (props) => {
    const { definition: { width, height, angle, extraRasterizerKey }, GenericRowRasterizer = DummyRasterizer, } = props;
    const { rows } = useMultiRow(props);
    const { PointerArea } = useContext(ComponentContext);
    return (React.createElement(React.Fragment, null,
        rows.map(rowDefinition => (React.createElement("svg", { key: rowDefinition.id, x: rowDefinition.x, y: rowDefinition.y, "data-hook": DH.MULTI_ROW_ROW },
            React.createElement(Row, { definition: rowDefinition, key: rowDefinition.id, realAngle: angle, GenericRowRasterizer: GenericRowRasterizer, disablePointerArea: true, rowDataHook: DH.MULTI_ROW_ROW_SEATS, extraRasterizerKey: extraRasterizerKey }),
            React.createElement(PointerArea, { width: rowDefinition.width, height: rowDefinition.height, "data-element-id": rowDefinition.id })))),
        React.createElement(PointerArea, { width: width, height: height })));
};
//# sourceMappingURL=multi-row.js.map